const { ColorPicker, Popover, ColorIndicator, FlexItem, Button, Icon } = wp.components;
import { Flex } from '@wordpress/components';
import { useSelect } from '@wordpress/data';
import { rotateLeft } from '@wordpress/icons';
import { useState } from '@wordpress/element';
import { setAttributesResponsive, getValueByPath } from '../../block/functions.js';
import { __ } from '@wordpress/i18n';
import './color-select.css';

const ColorSelector = ({ attributes, setAttributes, attributeName, label }) => {

    const currentDevice = useSelect((select) => {
        return select('core/edit-post').__experimentalGetPreviewDeviceType();
    }, []);
    const device = currentDevice.toLowerCase();
    const deviceString = device === 'desktop' ? '' : `:${device}`;
    const pathValue = attributeName.split('.').length > 1 ? attributeName.split('.')[0] + deviceString + '.' + attributeName.split('.').slice(1).join('.') : attributeName.split('.')[0] + deviceString;
    const [isOpen, setIsOpen] = useState(false);

    const toggleColorPicker = () => {
        setIsOpen(!isOpen);
    };

    const handleChange = (value) => {
        setAttributesResponsive(attributeName, value, device, setAttributes, attributes);
    };

    const handleResetColor = () => {
        setAttributesResponsive(attributeName, '', device, setAttributes, attributes);
    }

    return (
        <>
            <Flex className='softlite-color-box'>
                <FlexItem>
                    <label>{label ? label : 'Color'}</label>
                </FlexItem>
                <FlexItem>
                    <Button
                        icon={<Icon icon={rotateLeft} size={16} />}
                        label="Reset Color"
                        className="softlite-button-reset-color"
                        onClick={handleResetColor}
                    />
                    <ColorIndicator className="softlite-color-indicator" colorValue={getValueByPath(pathValue, attributes) ? getValueByPath(pathValue, attributes) : ''} onClick={toggleColorPicker} />
                </FlexItem>
            </Flex>

            {isOpen && (
                <Popover
                    position="bottom"
                    onClose={() => setIsOpen(false)}
                >
                    <ColorPicker
                        color={getValueByPath(pathValue, attributes) ? getValueByPath(pathValue, attributes) : ''}
                        onChange={(value) => handleChange(value)}
                    />
                </Popover>
            )}
        </>
    );
};



export default ColorSelector;